<template>
  <div>
    <list
      row-key="LeaveId"
      ref="list"
      unit="学生请假"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="true"
      :get-data-func="api.list"
      show-query2
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="节次类型">
          <el-select v-model="params.SectionType" clearable @change="query()">
            <el-option :value="0" label="上课节次"></el-option>
            <el-option :value="1" label="留宿节次"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="节次模式">
          <el-select v-model="params.SectionMode" clearable @change="query()">
            <el-option :value="0" label="连续节次"></el-option>
            <el-option :value="1" label="固定节次"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="请假类型">
          <el-select v-model="params.LeaveType" clearable>
            <el-option v-for="(item,index) in typeList" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.GradeId" @change="getClass" clearable>
            <template v-for="(i,index) in grades">
              <el-option :key="index" :value="i.GradeId" :label="i.Grade"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-select v-model="params.ClassId" clearable>
            <template v-for="(i,index) in classes">
              <el-option :key="index" :value="i.ClassId" :label="i.ClassName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input v-model="params.FullName" style="width:184px;" placeholder="请填写姓名"></el-input>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker
            v-model="params.StartDate"
            placeholder="请选择日期"
            clearable
            style="width:184px;"
            @input="sinput"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="开始节次">
          <el-select v-model="params.StartSectionId" clearable :disabled="!params.StartDate">
            <el-option
              v-for="item in sectionList"
              :key="item.SectionId"
              :value="item.SectionId"
              :label="item.SectionName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            v-model="params.EndDate"
            placeholder="请选择日期"
            @input="einput"
            style="width:184px;"
            clearable
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="结束节次">
          <el-select v-model="params.EndSectionId" clearable :disabled="!params.EndDate">
            <el-option
              v-for="item in sectionList"
              :key="item.SectionId"
              :value="item.SectionId"
              :label="item.SectionName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="params.Remark" placeholder="请输入备注" clearable></el-input>
        </el-form-item>
        <el-form-item label-width="17px">
          <el-checkbox v-model="params.Today">今日请假学生</el-checkbox>
        </el-form-item>
        <el-form-item label-width="17px">
          <el-checkbox v-model="params.Now">当前节次请假学生</el-checkbox>
        </el-form-item>
      </template>
      <template slot="query2">
        <el-form-item label="学生姓名" class="query2">
          <el-input v-model="params.FullName" placeholder="请填写姓名" style="width:184px;"></el-input>
        </el-form-item>
        <br />
        <el-form-item label-width="17px">
          <el-checkbox v-model="params.Today">今日请假学生</el-checkbox>
        </el-form-item>
        <el-form-item label-width="17px">
          <el-checkbox v-model="params.Now">当前节次请假学生</el-checkbox>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="FullName" label="学生姓名" />
        <el-table-column prop="ClassName" label="班级" min-width="90" />
        <el-table-column prop="LeaveType" label="请假类型" />
        <el-table-column prop="SectionType" label="节次类型">
          <template slot-scope="{row}">
            <span v-if="row.SectionType==0">上课节次</span>
            <span v-else-if="row.SectionType==1">留宿节次</span>
          </template>
        </el-table-column>
        <el-table-column prop="SectionMode" label="节次模式">
          <template slot-scope="{row}">
            <span v-if="row.SectionMode==0">连续节次</span>
            <span v-else-if="row.SectionMode==1">固定节次</span>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="录入时间" min-width="140" />
        <el-table-column prop="StartDate" label="请假开始日期" min-width="110">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.StartDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="EndDate" label="请假结束日期" min-width="110">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.EndDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="SectionNames" label="节次" min-width="180"></el-table-column>
        <el-table-column prop="Remark" label="备注" min-width="180px" show-overflow-tooltip />
        <slot name="column"></slot>
      </template>
    </list>
    <import-dialog ref="importDialog" @upload-success="reload" />
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import termApi from "@/api/ed/term";
import importDialog from "./importDialog";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: {
    list,
    exportDialog,
    importDialog,
  },
  data() {
    return {
      api: require("@/api/st/leave").default,
      sectionApi: require("@/api/ed/section").default,
      grade_api: require("@/api/ed/grade").default,
      class_api: require("@/api/ed/class").default,
      params: {
        TermId: null,
        TermName: "",
        TeacherId: null,
        StartDate: null,
        EndDate: null,
        GradeId: null,
        ClassId: null,
        FullName: "",
        StartSectionId: null,
        EndSectionId: null,
        ClassName: "",
        Remark: "",
        SectionType: 0,
        SectionMode: null,
        Today: true,
        Now: false,
        LeaveType: "",
        // LeaveMode: 0,
      },
      // GradeId: null,
      typeList: ["病假", "事假","走读", "公假", "校本课程", "校内其他"],
      termApi,
      termList: [],
      sectionList: [],
      grades: [],
      classes: [],
      isMB: this.$store.state.isMB,
    };
  },
  beforeMount() {
    if (sessionStorage.getItem("cn")) {
      this.params.ClassName = sessionStorage.getItem("cn");
      this.params.ClassId = Number(sessionStorage.getItem("cid"));
      this.params.Now = true;
      sessionStorage.removeItem("cn");
      sessionStorage.removeItem("cid");
    }
  },
  mounted() {
    let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.params.TeacherId = loginInfo.TeacherId;
    this.params.TermId = loginInfo.TermId;
    this.termApi.list().then((res) => {
      if (res.Data && res.Data.length > 0) {
        this.termList = res.Data;
        if (this.params.TermId) {
          res.Data.forEach((e) => {
            if (e.TermId == this.params.TermId) {
              this.params.TermName = e.TermName;
            }
          });
        } else {
          this.params.TermId = res.Data[0].TermId;
          this.params.TermName = res.Data[0].TermName;
        }
        sessionStorage.setItem("termId", this.params.TermId);
        this.$refs.list.initQueryParams.TermId = this.params.TermId;
        this.$refs.list.initQueryParams.TermName = this.params.TermName;
        this.query({ TermId: this.params.TermId });
      }
    });
    this.getGrade();
  },
  methods: {
    onImport() {
      this.$refs.importDialog.open().then((that) => {
        that.setData(this.params);
      });
    },
    onExport() {
      this.api.export(
        this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams)
      );
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    getSection(TermId, GradeId) {
      if (TermId && GradeId) {
        this.sectionApi.list({ TermId, GradeId }).then((res) => {
          this.sectionList = res.Data;
        });
      }
    },
    termChange(e) {
      sessionStorage.setItem("termId", e);
      var term = this.termList.find((x) => x.TermId == e);
      if (term) this.params.TermName = term.TermName;
      this.params.ClassName = "";
      this.params.ClassId = null;
      this.params.StartSectionId = null;
      this.params.EndSectionId = null;
      this.sectionList = [];
      this.getClass();
      this.getGrade();
      this.query({
        TermId: e,
        StartDate: this.params.StartDate,
        EndDate: this.params.EndDate,
      });
    },
    getGrade() {
      this.grade_api.list().then((res) => {
        this.grades = res.Data;
      });
    },
    getClass() {
      this.params.ClassId = null;
      if (!this.params.GradeId) {
        this.classes = [];
        return;
      }
      var params = { GradeId: this.params.GradeId, TermId: this.params.TermId };
      this.class_api.list(params).then((res) => {
        this.classes = res.Data;
      });
      this.getSection(this.params.TermId, this.params.GradeId);
    },
    sinput(e) {
      if (!e) {
        this.params.StartSectionId = null;
      }
    },
    einput(e) {
      if (!e) {
        this.params.EndSectionId = null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.query2 {
  width:100%;
  /deep/ label {
    width: 80px;
  }
}
</style>